import { inject, Injectable } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { SupportCenterDialogComponent, SupportCenterDialogData } from './support-center-dialog.component';

@Injectable({ providedIn: 'root' })
export class SupportCenterDialogFactory {
  private modalService = inject(NzModalService);

  open(data: SupportCenterDialogData): NzModalRef<SupportCenterDialogComponent> {
    return this.modalService.create<SupportCenterDialogComponent, SupportCenterDialogData>({
      nzTitle: 'Центр поддержки',
      nzContent: SupportCenterDialogComponent,
      nzData: data,
      nzFooter: null,
      nzWidth: 814,
      nzBodyStyle: { padding: '16px 24px' },
      nzWrapClassName: 'support-center-modal-wrap',
    });
  }
}
